import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom'
import { Container, Button, Icon, Image, Grid } from 'semantic-ui-react'
import { Helmet } from "react-helmet"
import moment from 'moment'

import game_model from 'models/game_model'
import game_play_model from 'models/game_play_model'

import { TimerProvider } from "xAppLib/Timer/TimerContext";

import Wordle from './Wordle'

import { WORDS_DICT } from "cont/words.js";

const DEBUG = false;

const Game = props => {

	const [game_data, setGame_data] = useState()
	const [gpid, setGpid] = useState()
	const [error, setError] = useState()

	// const word = WORDS_DICT[Math.floor(Math.random() * WORDS_DICT.length)]

	const passed_gid = props.match?.params?.gid || props?.gid || useParams().gid
	const gid = passed_gid || `wl-dy-`+moment().tz("Australia/Melbourne").format('YYMMDD')

	useEffect( async _ => {

		const _game_data = await game_model.get_game(gid, passed_gid ? 'set' : 'auto');

		if (!_game_data) {
			setError('Game not found or you do not have permission to view it.')
			return
		}

		const _gpid = await game_play_model.play_start('wordle', gid, {word: _game_data.word, max_guesses: _game_data.max_guesses, dict: _game_data.dict})

		setGame_data(_game_data)
		setGpid(_gpid)

		DEBUG && console.log('game_data loaded ', _game_data, gid, _gpid);

	}, [gid])

	return <Container>
			<Helmet>
				<title>{game_data?.name ? `WeWordle - ${game_data.name}` : 'WeWordle Game'}</title>
			</Helmet>

			{/*<pre>
			{JSON.stringify(app.user, null, 4)}
			</pre>*/}
			{error && (
				<div style={{
					marginTop: '48px',
					textAlign: 'center',
					padding: '40px 24px',
					background: '#fff5f5',
					borderRadius: '12px',
					border: '1px solid #fed7d7',
				}}>
					<div style={{fontSize: '48px', marginBottom: '16px'}}>🚫</div>
					<div style={{fontSize: '22px', fontWeight: '600', color: '#c53030', marginBottom: '8px'}}>
						Game Unavailable
					</div>
					<div style={{fontSize: '16px', color: '#744210'}}>{error}</div>
				</div>
			)}

			{game_data?.word && gpid &&
			<TimerProvider>
				<Wordle
					gid = {gid}

					{...game_data}

					// onStart = { w => game_play_model.add_record(gid,
					// 						{
					// 							guess: w,
					// 						},
					// 						{
					// 							timestamp: true,
					// 							add_by: true,
					// 						}
					// 					) }

					onCheck = { g => game_play_model.play_add_move(gpid, g) }

					onStat = { s => game_play_model.play_stat(gpid, s) }

					// word = {word}
					// max_guesses = {6}
					// // word_length = {5}
					// dict = {true}
				 />
			</TimerProvider>
			}

		</Container>
}

export default Game